module.exports = __webpack_public_path__ + "img/arrow-down.4036e3ae.svg";